export default __webpack_public_path__ + "static/media/liptionImg.3c032df5.png";